var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('resource',{attrs:{"title":"Ändern","resource":"coupon","resourceName":"Gutschein","original":_vm.original,"attributes":[
      {
        name: 'slug',
        label: 'Code',
        type: 'CodeSelector'
      },
      {
        name: 'start',
        label: 'Start',
        type: 'DateTimeSelector'
      },
      {
        name: 'end',
        label: 'Ende',
        type: 'DateTimeSelector'
      },
      {
        name: 'amount',
        label: 'Menge an Coins'
      },
      {
        name: 'for_one',
        label: 'Einmal einlösbar?',
        type: 'CheckboxSelector'
      },
      {
        name: 'active',
        label: 'Aktiv?',
        type: 'CheckboxSelector'
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Gutschein bearbeiten")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }